import { Action } from '@ngrx/store';
import { ProductsResponseOP, ProductOP, ContractOP, RmsContractBalance } from '@cemex-core/cmx-api';

export enum ActionTypes {
  FETCH = '[RMS OLC UL Products] Fetch',
  FETCH_SUCCESS = '[RMS OLC UL Products] Fetch Success',
  FETCH_FAILURE = '[RMS OLC UL Products] Fetch Failure',
  SELECT_PRODUCT = '[RMS OLC UL Products] Select Product',
  UPDATE_PRODUCT = '[RMS OLC UL Products] Update Product',
  FETCH_CONTRACT_BALANCE = '[RMS OLC UL Products] Fetch Contract Balance',
  FETCH_CONTRACT_BALANCE_SUCCESS = '[RMS OLC UL Products] Fetch Contract Balance Success',
  SELECT_CONTRACT = '[RMS OLC UL] Select Contract',
  RESET = '[RMS OLC UL] Reset',
}

export class Fetch implements Action {
  readonly type: string = ActionTypes.FETCH;

  constructor(public payload?: any) {}
}

export class FetchSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_SUCCESS;
  constructor(public payload: ProductsResponseOP) {}
}

export class FetchFailure implements Action {
  readonly type: string = ActionTypes.FETCH_FAILURE;
  constructor(public payload?: any) {}
}

export class SelectProduct implements Action {
  readonly type: string = ActionTypes.SELECT_PRODUCT;
  constructor(public payload: number) {}
}

export class UpdateProduct implements Action {
  readonly type: string = ActionTypes.UPDATE_PRODUCT;
  constructor(public payload: ProductOP) {}
}

export class FetchContractBalance implements Action {
  readonly type: string = ActionTypes.FETCH_CONTRACT_BALANCE;
  constructor(public payload: { product: ProductOP; contract: ContractOP }) {}
}

export class FetchContractBalanceSuccess implements Action {
  readonly type: string = ActionTypes.FETCH_CONTRACT_BALANCE_SUCCESS;
  constructor(public payload: RmsContractBalance[]) {}
}

export class SelectContract implements Action {
  readonly type: string = ActionTypes.SELECT_CONTRACT;
  constructor(public payload: number) {}
}

export class Reset implements Action {
  readonly type: string = ActionTypes.RESET;
  constructor(public payload?: any) {}
}

export type Actions =
  | Fetch
  | FetchSuccess
  | FetchFailure
  | SelectProduct
  | FetchContractBalance
  | FetchContractBalanceSuccess
  | SelectContract
  | UpdateProduct
  | Reset;
